var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.act)?_c('router-view'):(_vm.act === false)?_c('div',{staticClass:"tip"},[_vm._v("活动已下线")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }